import { CheckboxProps, Flex, Typography } from "antd";
import { observer } from "mobx-react-lite";
import styles from "./plateItem.module.css";
import { ReactNode } from "react";
import { DefaultCheckbox } from "ui";

type PlateItemHeaderProps = {
  checkbox?: {
    checkboxProps?: CheckboxProps;
  };
  headerContent: ReactNode;
};
export const PlateItemHeader = observer(({ checkbox, headerContent }: PlateItemHeaderProps) => {
  return (
    <div className={styles.headerItemComponent}>
      <Flex gap="small" className="full-width">
        {checkbox && <DefaultCheckbox {...checkbox.checkboxProps} />}
        {headerContent}
      </Flex>
    </div>
  );
});
